<template>
    <div class="dashboard_classification">
        <div class="main_div">
            <div class="headerTop pb-2">
                <div class="pr-5 pt-5 pb-0">
                    <NavigationTabs :activeTab="activeNavTab" @change="(tab) => activeNavTab = tab" />
                </div>
            </div>

            <div class="tab_content">
                <ResultadosTab v-if="activeNavTab === 'resultados'" />
                <VentasTab v-else-if="activeNavTab === 'ventas'" />
                <GastosTab v-else-if="activeNavTab === 'gastos'" />
                <div v-else class="p-5">
                    <h2 class="title is-4">{{ activeNavTabLabel }}</h2>
                    <p>Contenido para {{ activeNavTabLabel }} en desarrollo.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NavigationTabs from "@/components/generics/NavigationTabs.vue";
import ResultadosTab from "./financialReports/tabs/ResultadosTab.vue";
import VentasTab from "./financialReports/tabs/VentasTab.vue";
import GastosTab from "./financialReports/tabs/GastosTab.vue";

export default {
    name: "DashboardReports",
    components: {
        NavigationTabs,
        ResultadosTab,
        VentasTab,
        GastosTab
    },
    data() {
        return {
            activeNavTab: 'resultados',
        };
    },
    computed: {
        activeNavTabLabel() {
            const labels = {
                resultados: 'Resultados',
                ventas: 'Ventas',
                costos: 'Costos',
                gastos: 'Gastos',
                rentabilidad: 'Rentabilidad',
                no_oper: 'No Oper',
                activos: 'Activos'
            };
            return labels[this.activeNavTab] || this.activeNavTab;
        }
    }
};
</script>

<style lang="scss" scoped>
* {
    font-family: Inter;
}

.headerTop {
    position: sticky;
    top: 110px;
    width: 100%;
    background-color: white;
    z-index: 5;
    border-bottom: 1px solid #EAECF0;
}

.main_div {
    padding-left: clamp(10px, 5.5vw, 90px);
    padding-right: clamp(10px, 5.5vw, 93px);
    padding-bottom: 30px;
}

.tab_content {
    min-height: 400px;
}
</style>
